import React, { useState, useEffect } from 'react';
import { ExternalLink, X } from 'lucide-react';

// Lista completa de patrocinadores
const sponsors = [
  {
    id: 1,
    name: "Securtec360",
    tagline: "Seguridad creada por ingenieros",
    description: "Cámaras • Alarmas • Control de acceso • Oficial Virtual con IA",
    features: "Verificación, reportes y avisos automáticos",
    url: "https://www.securtec360.com",
    icon: "🛡️",
    color: "from-blue-600 to-blue-800"
  },
  {
    id: 2,
    name: "Monitoreo.app",
    tagline: "Monitoreo 24/7 con protocolos reales",
    description: "Recibimos alertas, verificamos y escalamos por WhatsApp según tu plan",
    features: "IA + evidencias + reportes",
    url: "https://www.monitoreo.app",
    icon: "🚨",
    color: "from-red-600 to-red-800"
  },
  {
    id: 3,
    name: "AirTrack",
    tagline: "GPS para flotas y oficiales",
    description: "Ubicación en vivo • Rutas • Reportes • Alertas por eventos",
    features: "IA para análisis y avisos",
    url: "https://www.airtrack.app",
    icon: "📍",
    color: "from-green-600 to-green-800"
  },
  {
    id: 4,
    name: "Conteo360",
    tagline: "Conteo en línea (ventas + seguridad)",
    description: "Personas (entrada/salida) + aperturas (puertas/portones)",
    features: "Dashboard multiempresa + reportes por sede + IA",
    url: "https://www.conteo360.com",
    icon: "📊",
    color: "from-purple-600 to-purple-800"
  },
  {
    id: 5,
    name: "TecLink",
    tagline: "Tickets y soporte sin enredos",
    description: "Mesa de ayuda • Evidencias • Órdenes de servicio • Seguimiento",
    features: "IA para clasificación y reportes",
    url: "https://www.teclink.app",
    icon: "🎫",
    color: "from-orange-600 to-orange-800"
  },
  {
    id: 6,
    name: "PatrolLink",
    tagline: "Rondas y patrullaje con trazabilidad",
    description: "Puntos de control • Recorridos • Incidencias • Reportes",
    features: "IA + alertas operativas",
    url: "https://www.patrollink.app",
    icon: "👮",
    color: "from-indigo-600 to-indigo-800"
  },
  {
    id: 7,
    name: "Vault",
    tagline: "Control de visitas y accesos",
    description: "Registro y autorización • Bitácora • Trazabilidad • Accesos",
    features: "IA para verificación y avisos",
    url: "https://www.controldevisitas.net",
    icon: "🧾",
    color: "from-teal-600 to-teal-800"
  },
  {
    id: 8,
    name: "Checkin360",
    tagline: "Check-in digital para Airbnb/condos",
    description: "Pre-registro • Validación de datos • Instrucciones • Automatizaciones",
    features: "Menos llamadas, más control (con IA)",
    url: "https://checkin360.app",
    icon: "🏠",
    color: "from-cyan-600 to-cyan-800"
  },
  {
    id: 9,
    name: "DeLaComunidad",
    tagline: "Portal para condominios y comunidades",
    description: "Avisos • Solicitudes • Organización • Comunicación centralizada",
    features: "IA + reportes y avisos",
    url: "https://www.delacomunidad.app",
    icon: "🏘️",
    color: "from-emerald-600 to-emerald-800"
  },
  {
    id: 10,
    name: "Blackout CR",
    tagline: "Cotiza soluciones blackout",
    description: "Página comercial para presentar, cotizar y vender servicios relacionados",
    features: "IA + atención rápida",
    url: "https://www.blackoutcr.com",
    icon: "🌑",
    color: "from-gray-700 to-gray-900"
  },
  {
    id: 11,
    name: "LPR",
    tagline: "Lectura de placas con reglas y alertas",
    description: "Listas blancas/negras • Bitácora • Notificaciones automáticas",
    features: "IA + evidencia y reportes",
    url: "https://www.securtec360.com",
    icon: "🚘",
    color: "from-amber-600 to-amber-800"
  },
  {
    id: 12,
    name: "TrailLink",
    tagline: "Seguridad para senderos y reservas",
    description: "Emergencias y comunicación en zonas sin señal celular",
    features: "Respuesta más rápida + control y reportes con IA",
    url: "https://www.securtec360.com",
    icon: "🌲",
    color: "from-lime-600 to-lime-800"
  },
  {
    id: 13,
    name: "PulseTag",
    tagline: "Identificación y accesos con tags/BLE",
    description: "Accesos por usuario • horarios • reglas • trazabilidad",
    features: "IA para alertas y reportes",
    url: "https://www.securtec360.com",
    icon: "🔑",
    color: "from-rose-600 to-rose-800"
  },
  {
    id: 14,
    name: "Torre de Vigilancia S360",
    tagline: "Ideal para fincas y perímetros",
    description: "Cámaras + sensores + energía + conectividad en un punto estratégico",
    features: "Disuasión + monitoreo + evidencias con IA",
    url: "https://www.securtec360.com",
    icon: "🗼",
    color: "from-sky-600 to-sky-800"
  },
  {
    id: 15,
    name: "Residenciales Abiertos S360",
    tagline: "Seguridad organizada",
    description: "Alertas comunitarias • coordinación • bitácoras • apoyo operativo",
    features: "IA + reportes y avisos",
    url: "https://www.securtec360.com",
    icon: "🏡",
    color: "from-fuchsia-600 to-fuchsia-800"
  },
  {
    id: 16,
    name: "Protegidos S360",
    tagline: "Seguridad integral como servicio",
    description: "Prevención + monitoreo + respuesta + evidencia y reportes",
    features: "Protocolos + escalamiento + IA",
    url: "https://www.securtec360.com",
    icon: "✅",
    color: "from-violet-600 to-violet-800"
  }
];

export const SponsorBanner = ({ variant = "default" }) => {
  const [currentSponsor, setCurrentSponsor] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Seleccionar un patrocinador aleatorio al montar
    const randomIndex = Math.floor(Math.random() * sponsors.length);
    setCurrentSponsor(sponsors[randomIndex]);

    // Rotar cada 30 segundos
    const interval = setInterval(() => {
      const newIndex = Math.floor(Math.random() * sponsors.length);
      setCurrentSponsor(sponsors[newIndex]);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  if (!currentSponsor || !isVisible) return null;

  // Variante compacta para sidebar
  if (variant === "compact") {
    return (
      <div className="bg-gradient-to-r from-primary/5 to-accent/5 border border-border rounded-xl p-4" data-testid="sponsor-banner-compact">
        <p className="text-xs text-muted-foreground mb-2 font-medium">Visita nuestros patrocinadores</p>
        <a
          href={currentSponsor.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block hover:opacity-90 transition-opacity"
        >
          <div className="flex items-center gap-3">
            <span className="text-2xl">{currentSponsor.icon}</span>
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-sm text-foreground truncate">{currentSponsor.name}</h4>
              <p className="text-xs text-muted-foreground truncate">{currentSponsor.tagline}</p>
            </div>
            <ExternalLink className="w-4 h-4 text-muted-foreground shrink-0" />
          </div>
        </a>
      </div>
    );
  }

  // Variante banner horizontal (default)
  return (
    <div 
      className="relative bg-gradient-to-r from-primary/10 via-accent/5 to-primary/10 border-y border-border py-3"
      data-testid="sponsor-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground font-medium whitespace-nowrap hidden sm:block">
            Visita nuestros patrocinadores
          </p>
          
          <a
            href={currentSponsor.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 flex-1 justify-center sm:justify-start hover:opacity-90 transition-opacity group"
          >
            <span className="text-xl">{currentSponsor.icon}</span>
            <div className="flex items-center gap-2">
              <span className="font-semibold text-sm text-foreground">{currentSponsor.name}</span>
              <span className="text-muted-foreground hidden md:inline">—</span>
              <span className="text-xs text-muted-foreground hidden md:inline">{currentSponsor.tagline}</span>
            </div>
            <ExternalLink className="w-3.5 h-3.5 text-muted-foreground group-hover:text-accent transition-colors" />
          </a>
          
          <button
            onClick={() => setIsVisible(false)}
            className="text-muted-foreground hover:text-foreground transition-colors p-1"
            aria-label="Cerrar"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

// Componente para mostrar todos los patrocinadores en una página dedicada
export const SponsorsGrid = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="sponsors-grid">
      {sponsors.map((sponsor) => (
        <a
          key={sponsor.id}
          href={sponsor.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block p-5 rounded-xl border bg-background hover:shadow-lg hover:border-accent/50 transition-all group"
        >
          <div className="flex items-start gap-4">
            <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${sponsor.color} flex items-center justify-center text-2xl text-white shadow-lg`}>
              {sponsor.icon}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-bold text-foreground group-hover:text-accent transition-colors">
                {sponsor.name}
              </h3>
              <p className="text-sm text-muted-foreground mt-1">{sponsor.tagline}</p>
            </div>
          </div>
          <p className="text-sm text-foreground/80 mt-3">{sponsor.description}</p>
          <div className="flex items-center gap-2 mt-3 text-xs text-accent">
            <span>✅</span>
            <span>{sponsor.features}</span>
          </div>
        </a>
      ))}
    </div>
  );
};

export default SponsorBanner;
